// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"831ac306bf7b454c2c320be9f2ffc23265a2ab75"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/ariza/assets/production-20250722092047-831ac306bf7b454c2c320be9f2ffc23265a2ab75";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.sentryDsn,
  enabled: process.env.NODE_ENV !== "test",
  release: process.env.sentryRelease,
  ignoreErrors: [],
});
